var map = {
	"./air-nga-en/assets/fantasy-logo-icon.png": 13484,
	"./ais-tai-tha/assets/fantasy-logo-icon.png": 99481,
	"./demo-arabic/assets/fantasy-logo-icon.png": 97473,
	"./demo-et-en/assets/fantasy-logo-icon.png": 99256,
	"./demo-romanian/assets/fantasy-logo-icon.png": 77906,
	"./ethiotel-et-amh/assets/fantasy-logo-icon.png": 23542,
	"./ethiotel-et-en/assets/fantasy-logo-icon.png": 87259,
	"./mtn-cg-fr/assets/fantasy-logo-icon.png": 63694,
	"./mtn-ci-fr/assets/fantasy-logo-icon.png": 23044,
	"./mtn-cmr-fr/assets/fantasy-logo-icon.png": 59536,
	"./mtn-gha-en/assets/fantasy-logo-icon.png": 22291,
	"./mtn-nga-en/assets/fantasy-logo-icon.png": 47839,
	"./mtn-zam-en/assets/fantasy-logo-icon.png": 76769,
	"./saf-ke-en/assets/fantasy-logo-icon.png": 47840,
	"./saudi-uae-en/assets/fantasy-logo-icon.png": 79249,
	"./tlk-za-en/assets/fantasy-logo-icon.png": 81996,
	"./vc-za-en/assets/fantasy-logo-icon.png": 91056
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20956;